// Icons aus dem SRS-Prototyp (16×16, Strich)
const P: Record<string, string> = {
  camp: '<path d="M2 14 8 3l6 11z"/><path d="M6.5 14 8 11l1.5 3"/>',
  session: '<rect x="2" y="3" width="12" height="10" rx="1.5"/><path d="M5 6v4M8 5v6M11 7v2"/>',
  compose: '<path d="M6 13V3l8-1.5v10"/><circle cx="4" cy="13" r="2"/><circle cx="12" cy="11.5" r="2"/>',
  klang: '<path d="M2 10V6M5 12V4M8 14V2M11 12V4M14 10V6"/>',
  mix: '<path d="M4 2v12M8 2v12M12 2v12"/><rect x="2.5" y="8" width="3" height="2.5" rx=".6"/><rect x="6.5" y="4" width="3" height="2.5" rx=".6"/><rect x="10.5" y="10" width="3" height="2.5" rx=".6"/>',
  splits: '<circle cx="8" cy="8" r="6"/><path d="M8 2v6l4.5 4"/>',
  ar: '<path d="M2 8s2.2-4.5 6-4.5S14 8 14 8s-2.2 4.5-6 4.5S2 8 2 8z"/><circle cx="8" cy="8" r="2"/>',
  katalog: '<path d="M3 2.5h7l3 3v8H3z"/><path d="M10 2.5v3h3M5.5 8h5M5.5 10.5h5"/>',
  dante: '<circle cx="8" cy="8" r="2"/><circle cx="2.5" cy="3" r="1.5"/><circle cx="13.5" cy="3" r="1.5"/><circle cx="8" cy="14" r="1.5"/><path d="M3.6 4.1 6.6 6.7M12.4 4.1 9.4 6.7M8 10v2.5"/>',
  spark: '<path d="M8 1.5 9.6 6.4 14.5 8 9.6 9.6 8 14.5 6.4 9.6 1.5 8 6.4 6.4z"/>',
  undo: '<path d="M5 3 2 6l3 3"/><path d="M2.5 6H10a3.5 3.5 0 0 1 0 7H6"/>',
  redo: '<path d="m11 3 3 3-3 3"/><path d="M13.5 6H6a3.5 3.5 0 0 0 0 7h4"/>',
};

export const Icon = ({ name, size = 15 }: { name: string; size?: number }) => (
  <svg viewBox="0 0 16 16" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round" dangerouslySetInnerHTML={{ __html: P[name] ?? '' }} />
);

export const SrsMark = ({ size = 36 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 36 36">
    <rect width="36" height="36" rx="8" fill="#003399" />
    <rect x=".5" y=".5" width="35" height="35" rx="7.5" fill="none" stroke="rgba(255,255,255,.28)" />
    <g transform="translate(6 6)" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l8 3.5V12c0 5-3.5 8.5-8 9.5-4.5-1-8-4.5-8-9.5V6.5z" /><path d="M8.5 12l2.5 2.5 4.5-5" />
    </g>
  </svg>
);
